import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

export const SubtotalLine = ({ preview, options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry
    label={preview?.future_payments?.start_on_phrase}
    value={preview?.future_payments?.formatted_subtotal}
    dataTestId="checkout-form-preview-future-payments-subtotal"
    {...options}
  />
);
